module.exports = __webpack_public_path__ + "img/ic-ic-check-border.9700fe29.svg";